<template>
  <div class>
    <div v-if="!showVerificationForm" class="d-flex justify-content-center"    :class="isSushi && 'montserrat-500'">
      <div class="col-12">
        <form class="pt-2 pb-4 d-flex flex-wrap justify-content-center" @submit.prevent="submit">
          <h3
            class="w-75 mt-3 mb-5 d-flex justify-content-center"
            v-if="isLogin"
          >{{ $t('message.signInToYourAccount') }}</h3>
          <h3
            class="w-75 mt-3 mb-5 d-flex justify-content-center"
            v-else
          >{{ $t('message.forgotPassword') }}</h3>
          <div class="form-group w-75">
            <label for="exampleInputEmail1">{{ $t('message.email') }}</label>
            <input
              v-validate="'required|email'"
              id="exampleInputEmail1"
              v-model="email"
              type="text"
              name="email"
              class="form-control"
              aria-describedby="emailHelp"
            />
            <div class="invalid-feedback">{{ OOErrors.first("email") | inputNameLocale("email") }}</div>
          </div>
          <div class="form-group w-75" v-if="isLogin">
            <label for="exampleInputPassword1">{{ $t('message.password') }}</label>
            <input
              v-validate="'required'"
              id="exampleInputPassword1"
              v-model="password"
              type="password"
              name="password"
              class="form-control"
            />
            <div
              class="invalid-feedback"
            >{{ OOErrors.first("password") | inputNameLocale("password")}}</div>
          </div>
          <div class="w-75 mt-1" v-if="isLogin">
            <a
              href="#"
              @click="switchView(false)"
              :style="desktopStyles.LinkColorTxt"
              style="float: right;margin-top: -0.875rem;"
            >{{ $t('message.forgotPassword') }}?</a>
          </div>
          <div class="w-75 mt-1" v-else>
            <a
              href="#"
              @click="switchView(true)"
              style="float: right;margin-top: -0.875rem;"
              :style="desktopStyles.LinkColorTxt"
            >{{ $t('message.login') }}</a>
          </div>
          <div class="w-75 mt-4 justify-content-center">

            <p
              style="font-size:0.6875rem;line-height: 1.4;text-align: center;"
            >
              {{$t('message.byContinuingYouAgreeToOur')}}
              <a href="#" @click.prevent="termsClick()">
                <b>
                  {{$t('message.termsOfUsePrivacyStatement')}}
                </b>
              </a>
            </p>
          </div>
          <div class="w-75 d-flex justify-content-between">
            <button
              v-if="isLogin"
              :disabled="loading"
              type="submit"
              class="btn btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center fs-1 fw-600"
              :class="isSushi && 'background-sushi border-0'"
              :style="!isSushi && desktopStyles.btn"
            >
              {{ $t('message.signIn') }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
            <button
              v-else
              :disabled="loading"
              type="submit"
              class="btn btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center fs-1 fw-600"
              :class="isSushi && 'background-sushi border-0'"
              :style="!isSushi && desktopStyles.btn"
            >
              {{ $t('message.sendLink') }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>
          <div class="w-75 mt-5 mb-5 d-flex justify-content-center">
            {{ $t('message.haventGotAnAccount') }} ? &nbsp;
            <a
              href="#"
              :style="desktopStyles.LinkColorTxt"
              @click="$emit('show-register')"
            >{{ $t('message.register') }}</a>
          </div>
          <div v-if="FacebookLogin || GoogleLogin" class="w-75 mb-3 d-flex justify-content-center">
            <strong>{{ $t('message.orSignInWith') }}</strong>
          </div>
          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
          <div v-show="msg" class="w-75 mt-4">
            <div class="alert alert-success" role="alert">
              <strong>{{ msg }}</strong>
            </div>
          </div>

          <div class="container">
            <div class="row mb-4 justify-content-center">
              <auth-providers-login @close-overlay="$emit('close-overlay')" />
            </div>
          </div>
        </form>
      </div>
    </div>
    <SMSVerification v-else @completed="close()"></SMSVerification>
    <termsAndConditionsModal v-if="showModal" @close-modal="closeModal" />
  </div>
</template>

<script>
import shared from "../../sharedscripts/user/login.js";
import AuthProvidersLogin from "./AuthProvidersLogin";
import SMSVerification from './SMSVerification.vue';

import { mapGetters } from "vuex";
import termsAndConditionsModal from "../shop/partials/termsAndConditionsModal.vue";

export default {
  components: {
    AuthProvidersLogin,
    SMSVerification,
    termsAndConditionsModal
  },
  props: {
    storeid: {
      type: String,
      default: null
    },
    forgift: {
      type: Boolean,
      default: false
    },
    showedindrawer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLogin: true,
      email: "",
      password: "",
      loading: false,
      error: "",
      msg: "",
      showModal: false
    };
  },
  computed: {
    ...mapGetters([
      "desktopStyles",
      "viewConfig",
      "currentStoreDoc",
      "dbuser",
      "showOverlay",
        "hqDoc"
    ]),
    FacebookLogin() {
      return this.viewConfig.FacebookLogin;
    },
    GoogleLogin() {
      return this.viewConfig.GoogleLogin;
    },
    showVerificationForm() {
      return this.currentStoreDoc &&
        this.currentStoreDoc.ViewComponentConfigs &&
        this.currentStoreDoc.ViewComponentConfigs.LogIn &&
        this.currentStoreDoc.ViewComponentConfigs.LogInMandatory &&
        this.currentStoreDoc.ViewComponentConfigs.SMSVerification &&
        this.dbuser &&
        (
          !this.dbuser.isVerified ||
          this.showOverlay
        );
    },

    isSushi() {
      return this.hqDoc && this.hqDoc.IsSushiHub;
    }
  },
  mounted() {
    this.setStoreLoaded();
  },
  methods: {
    ...shared.methods,
    close() {
      this.$emit("close-overlay");
    },
    closeModal() {
      this.showModal = false;
    },
    termsClick(){
      if(this.showedindrawer)
      {
        this.$emit('show-term');
      }else
      {
        this.showModal = true;
      }
    }
  }
};
</script>
